/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfGetAllPaidTrafficOrderOutput } from "../models/AjaxResponseOfGetAllPaidTrafficOrderOutput";
import type { AjaxResponseOfInstagramOutput } from "../models/AjaxResponseOfInstagramOutput";
import type { AjaxResponseOfPaidTrafficOrderDto } from "../models/AjaxResponseOfPaidTrafficOrderDto";
import type { AjaxResponseOfPlatformsVehicleDetails } from "../models/AjaxResponseOfPlatformsVehicleDetails";
import type { AjaxResponseOfPostizIntegration } from "../models/AjaxResponseOfPostizIntegration";
import type { CreateOrderWrapper } from "../models/CreateOrderWrapper";
import type { OrderStatus } from "../models/OrderStatus";
import type { OrderType } from "../models/OrderType";
import type { PostType } from "../models/PostType";
import type { SocialMediaProvider } from "../models/SocialMediaProvider";
import type { UpdatePaidTrafficOrderInput } from "../models/UpdatePaidTrafficOrderInput";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class PaidTrafficAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfGetAllPaidTrafficOrderOutput Success
   * @throws ApiError
   */
  public getAllPaidTrafficOrders({
    filter,
    lastEvaluatedKey,
    isHidden,
    orderStatus,
    orderType,
    provider,
    postType,
    shortcode,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    lastEvaluatedKey?: string;
    isHidden?: boolean;
    orderStatus?: OrderStatus;
    orderType?: OrderType;
    provider?: SocialMediaProvider;
    postType?: PostType;
    shortcode?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfGetAllPaidTrafficOrderOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/paid-traffic",
      query: {
        filter: filter,
        lastEvaluatedKey: lastEvaluatedKey,
        isHidden: isHidden,
        orderStatus: orderStatus,
        orderType: orderType,
        provider: provider,
        postType: postType,
        shortcode: shortcode,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public createOrder({
    requestBody,
  }: {
    requestBody?: CreateOrderWrapper;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/paid-traffic",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public updatePendingOrder({
    requestBody,
  }: {
    requestBody?: UpdatePaidTrafficOrderInput;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/paid-traffic",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfInstagramOutput Success
   * @throws ApiError
   */
  public getAllPosts({
    filter,
    lastEvaluatedKey,
    isHidden,
    orderStatus,
    orderType,
    provider,
    postType,
    shortcode,
    sorting,
    skipCount,
    maxResultCount,
  }: {
    filter?: string;
    lastEvaluatedKey?: string;
    isHidden?: boolean;
    orderStatus?: OrderStatus;
    orderType?: OrderType;
    provider?: SocialMediaProvider;
    postType?: PostType;
    shortcode?: string;
    sorting?: string;
    skipCount?: number;
    maxResultCount?: number;
  }): CancelablePromise<AjaxResponseOfInstagramOutput> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/paid-traffic/social-media-posts",
      query: {
        filter: filter,
        lastEvaluatedKey: lastEvaluatedKey,
        isHidden: isHidden,
        orderStatus: orderStatus,
        orderType: orderType,
        provider: provider,
        postType: postType,
        shortcode: shortcode,
        sorting: sorting,
        skipCount: skipCount,
        maxResultCount: maxResultCount,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public syncSocialMedia(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/paid-traffic/sync-social-media",
    });
  }
  /**
   * @returns AjaxResponseOfPostizIntegration Success
   * @throws ApiError
   */
  public getUserInstagramInformation(): CancelablePromise<AjaxResponseOfPostizIntegration> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/paid-traffic/user-information",
    });
  }
  /**
   * @returns AjaxResponseOfPlatformsVehicleDetails Success
   * @throws ApiError
   */
  public getVehicleByProviderId({
    providerId,
  }: {
    providerId: string;
  }): CancelablePromise<AjaxResponseOfPlatformsVehicleDetails> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/paid-traffic/vehicle-by-provider/{providerId}",
      path: {
        providerId: providerId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }
  /**
   * @returns void
   * @throws ApiError
   */
  public deletePaidTrafficOrder({
    id,
  }: {
    id: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/paid-traffic/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfPaidTrafficOrderDto Success
   * @throws ApiError
   */
  public getPaidTrafficOrder({
    id,
  }: {
    id: string;
  }): CancelablePromise<AjaxResponseOfPaidTrafficOrderDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/paid-traffic/{id}",
      path: {
        id: id,
      },
    });
  }
}
